// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './index.vue'
import router from './router'
import '@/assets/css/normalize.css'
import '@/assets/css/common.css'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/pages/index/index.js